import React, { useEffect, useState } from "react";

const KEY = "soma_first_cup_tip_seen";

export default function FirstCupTip() {
  const [show, setShow] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    let seen = false;
    try { seen = !!localStorage.getItem(KEY); } catch { seen = false; }
    if (!seen) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    setLeaving(true);
    try { localStorage.setItem(KEY, "1"); } catch { /* private mode is fine */ }
    setTimeout(() => setShow(false), 320);
  };

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(dismiss, 11000);
    return () => clearTimeout(t);
  }, [show]);

  if (!show) return null;

  return (
    <div
      data-testid="first-cup-tip"
      style={{
        position: "fixed",
        left: "50%",
        bottom: 24,
        transform: `translateX(-50%) translateY(${leaving ? "20px" : "0"})`,
        opacity: leaving ? 0 : 1,
        transition: "opacity 0.32s ease, transform 0.32s ease",
        zIndex: 9999,
        width: "min(440px, calc(100vw - 32px))",
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "14px 16px",
        borderRadius: 16,
        background: "rgba(43, 30, 21, 0.96)",
        border: "1px solid rgba(243,233,214,0.20)",
        boxShadow: "0 12px 40px rgba(0,0,0,0.5)",
        backdropFilter: "blur(8px)",
      }}
    >
      <span
        aria-hidden
        style={{
          flexShrink: 0,
          width: 34,
          height: 34,
          borderRadius: 17,
          border: "1px solid rgba(243,233,214,0.20)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--gold)",
          fontSize: 16,
        }}
      >
        ☕
      </span>
      <p
        style={{
          margin: 0,
          flex: 1,
          fontFamily: "'IM Fell English', Georgia, serif",
          fontSize: 14,
          lineHeight: 1.45,
          color: "var(--cream-soft)",
        }}
      >
        For the clearest reading, brew a press or loose-leaf — the grounds are what we read. ✦
      </p>
      <button
        type="button"
        data-testid="first-cup-tip-dismiss"
        onClick={dismiss}
        aria-label="Dismiss tip"
        style={{
          flexShrink: 0,
          background: "transparent",
          border: "none",
          color: "var(--dim)",
          fontSize: 18,
          lineHeight: 1,
          cursor: "pointer",
          padding: 4,
        }}
      >
        ×
      </button>
    </div>
  );
}
